import { Link } from "react-router-dom";
import { siteStats } from "@/mocks/site";

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden" aria-label="平台介绍">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20dark%20editorial%20background%20with%20deep%20charcoal%20ink%20tones%20and%20a%20single%20shaft%20of%20warm%20amber%20light%20through%20soft%20paper%20texture%2C%20faint%20vermillion%20red%20mist%20in%20the%20lower%20corner%2C%20minimal%20atmospheric%20wide%20banner%20art%20direction%20for%20a%20serious%20investigative%20journalism%20platform%2C%20cinematic%20film%20grain%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=hero-zhibao-cover-2026&orientation=landscape"
          alt="直曝网络爆料投稿平台首屏背景"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>

      <div className="relative w-full px-4 md:px-6 pt-16 md:pt-24 pb-14 md:pb-20">
        <div className="max-w-4xl mx-auto text-center animate-rise">
          <p className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white/12 backdrop-blur border border-white/25 text-white/90 text-xs font-label">
            <i className="ri-lock-2-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            无需注册 · 匿名投稿 · 身份全程保护
          </p>

          <h1 className="mt-6 font-heading text-3xl md:text-5xl lg:text-[56px] font-bold text-white leading-tight md:leading-[1.2]">
            直曝 · 让每一条真实线索
            <br className="hidden md:block" />
            安全直达编辑视野
          </h1>

          <p className="mt-5 md:mt-6 text-base md:text-lg text-white/85 leading-relaxed max-w-2xl mx-auto">
            从消费纠纷到行业内幕，从身边小事到公共议题。写下你知道的事，剩下的交给我们。
            投稿不设门槛，联系方式可以留空。
          </p>

          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/submit"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-label font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-send-plane-fill w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              立即投稿线索
            </Link>
            <Link
              to="/leads"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-white/12 backdrop-blur border border-white/30 text-white text-sm md:text-base font-label font-medium whitespace-nowrap hover:bg-white/20 transition-colors cursor-pointer"
            >
              <i className="ri-book-open-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              浏览线索库
            </Link>
          </div>
        </div>

        <dl className="mt-12 md:mt-16 max-w-5xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/15 rounded-lg overflow-hidden border border-white/15">
          {siteStats.map((stat) => (
            <div key={stat.label} className="bg-black/25 backdrop-blur px-4 py-5 md:py-6 text-center">
              <dt className="order-2 mt-1 text-xs md:text-sm text-white/70 font-label">{stat.label}</dt>
              <dd className="font-heading text-xl md:text-2xl font-bold text-accent-400">{stat.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}